export default __webpack_public_path__ + "images/57e7c5c275da25e0a954e30fcdc03d69.svg";